var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuesAnsChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    filter: "url(#filter0_d_1285_629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_6_Help"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.20703 50.1881V15.0319C6.20703 8.83597 11.2298 3.81311 17.4258 3.81311H52.5739C58.7698 3.81311 63.7927 8.83597 63.7927 15.0319V50.1881C63.7927 56.384 58.7698 61.4069 52.5739 61.4069H17.4258C11.2299 61.4069 6.20703 56.384 6.20703 50.1881Z",
    fill: "#8C7DFB",
    stroke: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M50.4541 30.3252H44.6182V18.0088C44.6182 15.7178 42.7549 13.8604 40.4697 13.8604H19.6045C17.3193 13.8604 15.4561 15.7178 15.4561 18.0088V33.2725C15.4561 35.5576 17.3193 37.4209 19.6045 37.4209H20.7354V42.4307C20.7354 42.6592 20.8701 42.8643 21.0752 42.9639C21.2861 43.0576 21.5264 43.0225 21.7021 42.876L28.1123 37.4209H33.5147V43.2979C33.5147 45.5537 35.3486 47.3877 37.6045 47.3877H45.333L49.833 51.2197C50.0088 51.3662 50.2549 51.4014 50.46 51.3076C50.6709 51.208 50.7998 51.0029 50.7998 50.7744V47.3701C52.8975 47.1943 54.5439 45.4365 54.5439 43.2979V34.415C54.5439 32.1592 52.71 30.3252 50.4541 30.3252ZM30.6201 31.667C30.6201 31.9893 30.3623 32.2529 30.0342 32.2529C29.7119 32.2529 29.4482 31.9893 29.4482 31.667V31.2568C29.4482 30.9346 29.7119 30.6709 30.0342 30.6709C30.3623 30.6709 30.6201 30.9346 30.6201 31.2568V31.667ZM30.626 27.0205V28.8896C30.626 29.2119 30.3623 29.4756 30.04 29.4756C29.7178 29.4756 29.4541 29.2119 29.4541 28.8896V26.4756C29.4541 26.1475 29.7178 25.8896 30.04 25.8896C31.8916 25.8896 33.3916 24.3779 33.3916 22.5264C33.3916 20.6807 31.8916 19.1748 30.04 19.1748C28.1885 19.1748 26.6826 20.6807 26.6826 22.5264C26.6826 22.8486 26.4189 23.1123 26.0967 23.1123C25.7686 23.1123 25.5107 22.8486 25.5107 22.5264C25.5107 20.0303 27.5439 18.0029 30.04 18.0029C32.5361 18.0029 34.5635 20.0303 34.5635 22.5264C34.5635 24.8291 32.8467 26.7334 30.626 27.0205ZM53.3721 43.2979C53.3721 44.9092 52.0654 46.2158 50.4541 46.2158H50.2139C49.8916 46.2158 49.6279 46.4795 49.6279 46.8018V49.5088L45.9248 46.3564C45.8193 46.2627 45.6846 46.2158 45.5498 46.2158H37.6045C35.9932 46.2158 34.6865 44.9092 34.6865 43.2979V37.4209H40.4697C42.7549 37.4209 44.6182 35.5576 44.6182 33.2725V31.4971H50.4541C52.0654 31.4971 53.3721 32.8096 53.3721 34.415V43.2979Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1285_629",
    x: 0.0999999,
    y: -0.290015,
    width: 73.8,
    height: 73.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1285_629"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1285_629",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuesAnsChatIcon);
export default __webpack_public_path__ + "static/media/ques-ans-chat-icon.8d31ba3d61b3a783e152d4dc4b8a0488.svg";
export { ForwardRef as ReactComponent };